import axios from 'axios'
import Vue from 'vue'
import { idTokenInvalid } from '@/assets/js/common'
import config from '@/config'

const getToken = process.env.NODE_ENV === 'development'
  ? config.dev.getToken
  : config.build.getToken;
const url_gethost = process.env.NODE_ENV === 'development'
  ? config.dev.url_gethost
  : config.build.url_gethost;

const url_getWebHost = process.env.NODE_ENV === 'development'
  ? config.dev.url_getWebHost
  : config.build.url_getWebHost;

Vue.baseURL = null;
Vue.token = null;

const myAxios = axios.create();
// 请求拦截器
myAxios.interceptors.request.use(
  config => {
    // 在发送请求前做些什么，一定要将配置信息返回出去
    return getConfig(config);
  },
  err => {
    // 对请求错误做些什么
    alert('网络异常')
    return Promise.reject(err)
  }
)
// 响应拦截器
myAxios.interceptors.response.use(
  res => {
    // 对响应数据做些什么，一定要将响应数据返回出去
    return res.data
  },
  err => {
    // 对响应错误做些什么
    console.log('响应失败', err);
    if (err.response.status === 401) {
      idTokenInvalid()
    }
    return Promise.reject(err)
  }
)
async function getBaseURL() {
  let res;
  if (systemInfo.environment === 'APP') {
    res = await axios.get(url_gethost)
    return res.data['lucy6']+"/market-1.0";
  } else {
    res = await axios.get(url_getWebHost)
    return res.data['lucy-open']+"/market-1.0";
  }
}
async function getConfig(config) {
  if (!Vue.baseURL) {
    const baseURL = await getBaseURL()
    console.log('接口基本路径', baseURL);
    Vue.baseURL = baseURL;
  }
  config.baseURL = Vue.baseURL;
  if (systemInfo.environment === 'APP') {
    if (!Vue.token) {
      const token = await getToken()
      console.log('token', token);
      Vue.token = token;
    }
    config.headers['x-id-token'] = Vue.token;
  }

  let obj = window.paiLaApi.getPailaHeader()
  for (const element in obj) {
    config.headers[element] = obj[element]
  }
  // config.headers.common['x-id-token'] = 'eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJhdXRoMHxhbm9ueW1vdXMiLCJndHAiOiJwYXNzd29yZCIsImNvb2tpZSI6IiIsImF6cCI6IiIsInNjb3BlIjoiIiwibG9naW5OYW1lIjoiIiwiY3VzdG9tZXJJZCI6ImFub255bW91cyIsImV4cCI6MTcxNTM0MzA4NSwianRpIjoialpEcXBBQ0t1N2RjakRsV2V0UTVLQSIsImlhdCI6MTYxNTM0MzA4NiwibmJmIjoxNjE1MzQzMDI2fQ.NIAmGzUm1Dhto3fj9hYaPUVrGx8w3a6pd-Ma_NgxXqrT8qiPwT8I4RZ6RAGFhbzZU4Rif2sLD_ufj5I2sZJyigYpUGvedZv6_iBGhnjI8MwsOQrTKDI_uHXmcTz-SyMEDX_o9qiQVOvo3h71UV9OdaykNOdfUkSjchkxkX5zPj4pAuGhNVrA71BSf7rnWRaECw0XuxdUc7ImBfr6iCfqXvG_raajw7f3NTTLGS66g74-JB5G3ZAVHbAdPtxTmXHKSZfcwXg2cB8FIhH6QigV2lqIotNltEFiENgoTtWALSoNRrCw2z40Rl6_FQpN5w1cibRz076EedF1uAb5K__rUQ';
  return config;
}
export default myAxios;